export default {
  title: {
    downloadData: "他社連携用CSV出力",
    downloadDataHistories: "出力履歴"
  },
  range: "期間",
  format: "フォーマット",
  completedReception: "受付完了",
  outputDate: "出力日時",
  status: "ステータス",
  user: "ユーザー",
  fileName: "ファイル名",
  fileFormat: "形式",
  logiAttendance: "ロジ勤怠",
  detail: "詳細",
  creating: "作成中",
  createComplate: "作成完了",
  messages: {
    acceptedDownload: "ダウンロードを受け付けました。",
    outputCompletedAfterEmailNotification: "出力完了後メールでお知らせします。",
    operationOfficeRequired: "運営会社を選択してください。",
    clickForDetails: "クリックして詳細を表示",
    failed: "作成に失敗しました",
    noData: "データがありません。"
  },
  details: 'TripID: { tripId } 出庫: { leaving } 帰庫: { returning }'
}
